module.exports = __webpack_public_path__ + "static/media/i-intro_ta_pro_subscription_logo.e23f75c0.png";